import ProductTeaser from '../product-teaser/product-teaser';
import { dispatchCustomEvent } from '../../../js/utils';

export default class CorporateGiftsBar {
  constructor() {
    this.cgBarContainerEl = document.querySelector('.js-swa-cg-bar');
    this.cgBarTriggerEl = document.querySelector('.js-swa-cgbar-trigger');
  }

  toggleBarDropdown() {

    if (this.cgBarTriggerEl) {
      this.initProductTeaserCarousel();

      this.cgBarTriggerEl.addEventListener('click', () => {
        this.cgBarContainerEl.classList.toggle('swa-cg-bar--expanded');
      });
    }
  }

  initProductTeaserCarousel() {

    // Product teaser carousel initialization
    window.cgProductTeaserClass = [];

    const productTeaserElement = this.cgBarContainerEl.querySelector('.js-swa-product-teaser');
    if (!productTeaserElement) {
      return;
    }

    const productTeaserRef = new ProductTeaser(productTeaserElement);
    productTeaserRef.init();

    dispatchCustomEvent('swaCgProductTeaserInitialized');

    this.cgBarContainerEl.addEventListener('swaCgProductTeaserUpdate', () => {
      productTeaserRef.refreshCarousel();

      // Selects last slide on all updates (add / remove)
      let slidesWithinCarousel = productTeaserRef.productTeaserCarouselSelector.querySelectorAll('.splide__slide');
      if (slidesWithinCarousel) {
        productTeaserRef.selectCustomSlide(slidesWithinCarousel.length);
      }
    });
  }

  init() {

    // If no corporate-gifts-bar El, return
    if (!this.cgBarContainerEl) {
      return;
    }

      this.toggleBarDropdown();
  }
}
